import { useCallback, useRef } from "react";

type Props = {
  onCanvasReady: (canvas: HTMLCanvasElement) => void;
  ready: boolean;
};

export function EmulatorView({ onCanvasReady, ready }: Props) {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const initRef = useRef(false);

  const setCanvasRef = useCallback(
    (node: HTMLCanvasElement | null) => {
      if (node && !initRef.current) {
        initRef.current = true;
        canvasRef.current = node;
        onCanvasReady(node);
      }
    },
    [onCanvasReady]
  );

  return (
    <div className="nes-panel relative">
      <div className="nes-panel-header">GAME</div>
      <div className="relative bg-black flex items-center justify-center" style={{ minHeight: "480px" }}>
        <canvas
          ref={setCanvasRef}
          className="block"
          style={{
            imageRendering: "pixelated",
            width: "512px",
            height: "480px",
          }}
        />
        {/* CRT scanline overlay */}
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background:
              "repeating-linear-gradient(0deg, rgba(0,0,0,0.15) 0px, rgba(0,0,0,0.15) 1px, transparent 1px, transparent 3px)",
            mixBlendMode: "multiply",
          }}
        />
        {!ready && (
          <div className="absolute inset-0 flex items-center justify-center bg-black/80">
            <span className="text-nes-gold font-pixel text-sm animate-pulse">
              LOADING...
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
